define('flight-components/mixins/withListingsModal',[
  'App',
  'flight/lib/compose',
  'flight-components/mixins/withListings',
  'flight-components/mixins/withModal',
  'flight-components/Listing',
  'flight-components/LiteEmailSignup',
  'flight-components/GoogleWallet'
],

function(App, compose, withListings, withModal, Listing, LiteEmailSignup, GoogleWallet) {


  var withListingsModal = function withListingsModal() {

    compose.mixin(this, [withListings, withModal]);

    this.defaultAttrs({

    });


    /**
     * Reveal a single listing within  a modal
     *
     * @overrides mixin:withListing
     */
    this.around('viewListing', function(superFn, listing){
      var listingType, modalId;
      var addrId = '';

      if (typeof listing.addressId !== 'undefined') {
        addrId = '_' + listing.addressId;
      }

      var getOfferUrl = '/getoffer?componentUID=' + listing.componentUid + addrId + '&ajax=true';

      // pass in print parameter when device is desktop
      // so backend knows to increment print limit count
      if (App.user.device.type === 'desktop') {
        getOfferUrl += '&print=true';
      }

      /** figures out the proper ID attribute given listing type */
      modalId = '#modal-listing--' + listing.listingType;

      /** activates the modal */
      this.activateModal({
        url: getOfferUrl,
        attr: {
          id: modalId
        }
      });
    });


    this.attachComponents = function(ev, data) {
      Listing.attachTo('.modal', {checkUrlState: false});
      GoogleWallet.attachTo( '.js-google-wallet' );
      LiteEmailSignup.attachTo( '.modal' );
    }

    this.after('killModal', function() {
      LiteEmailSignup.teardownAll();
      Listing.teardownAll();
      GoogleWallet.teardownAll();
    });


    this.after('initialize', function() {
      this.on('uiModalActivated', this.attachComponents);
    });

  };

  return withListingsModal;

});

